/**
 * Safely reads from localStorage with fallback to sessionStorage
 * This is critical for iOS Safari which has race conditions with localStorage writes
 * especially on first-time QR code scans
 */
 
export const getSafeTableId = () => {
    try {
        // Try localStorage first
        let tblid = localStorage.getItem("tblid");
 
        // If not found or invalid in localStorage, try sessionStorage (iOS Safari backup)
        if (!tblid || tblid === "null" || tblid === "undefined") {
            tblid = sessionStorage.getItem("tblid");
        }
 
        // Parse and return
        const parsedId = tblid ? Number(tblid) : 0;
        return isNaN(parsedId) ? 0 : parsedId;
    } catch (error) {
        console.error("Error reading table ID:", error);
        return 0;
    }
};
 
export const getSafeTableName = () => {
    try {
        // Try localStorage first
        let tblname = localStorage.getItem("tblname");
 
        // If not found in localStorage, try sessionStorage (iOS Safari backup)
        if (!tblname || tblname === "null" || tblname === "undefined") {
            tblname = sessionStorage.getItem("tblname");
        }
 
        // Parse JSON if exists
        if (tblname && tblname !== "null" && tblname !== "undefined") {
            try {
                return JSON.parse(tblname);
            } catch {
                return tblname;
            }
        }
 
        return "";
    } catch (error) {
        console.error("Error reading table name:", error);
        return "";
    }
};
 
export const getSafeCompanyId = () => {
    try {
        let companyId = localStorage.getItem("companyId");
 
        if (!companyId || companyId === "null" || companyId === "undefined") {
            companyId = sessionStorage.getItem("companyId");
        }
 
        return companyId ? JSON.parse(companyId) : null;
    } catch (error) {
        console.error("Error reading company ID:", error);
        return null;
    }
};
 
export const getSafeLocationId = () => {
    try {
        let locationId = localStorage.getItem("locationId");
 
        if (!locationId || locationId === "null" || locationId === "undefined") {
            locationId = sessionStorage.getItem("locationId");
        }
 
        return locationId ? JSON.parse(locationId) : null;
    } catch (error) {
        console.error("Error reading location ID:", error);
        return null;
    }
};